// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_g8-0";